'use strict';

var _config = require('config');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Function to add prefix to links.
var prefixLink = function prefixLink(_link) {
  if (typeof __PREFIX_LINKS__ !== 'undefined' && __PREFIX_LINKS__ !== null && __PREFIX_LINKS__ && _config.config.linkPrefix !== null) {
    var invariantMessage = '\n    You\'re trying to build your site with links prefixed\n    but you haven\'t set \'linkPrefix\' in your config.toml.\n    ';
    (0, _invariant2.default)((0, _isString2.default)(_config.config.linkPrefix), invariantMessage);

    return _config.config.linkPrefix + _link;
  } else {
    return _link;
  }
};

module.exports = {
  prefixLink: prefixLink
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/gatsby/dist/isomorphic/gatsby-helpers.js
 ** module id = 362
 ** module chunks = 0
 **/